/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import "./Card4.style.scss"

type Props = {
  icon: string
  title: string
  description: string,
  active?: boolean
}

const Card4: FC<Props> = ({icon, title, description, active }) => {
  return (
    <div className='card h-100'>
      <div className={'card-body d-flex justify-content-center text-center flex-column p-5 ' + (active ? "bg-light-primary" : "")}>
        <a href='#' className='text-gray-800 text-hover-primary d-flex flex-column'>
          <div className='symbol symbol-25px mb-4'>
            <KTSVG path={icon} className={`svg-icon svg-icon-2x ` + (active ? "svg-icon-primary" : "")} />
          </div>
          <div className='fs-5 fw-bolder mb-2'>{title}</div>
        </a>
        <div className='fs-7 fw-bold text-gray-400 mt-auto'>{description}</div>
      </div>
    </div>
  )
}

Card4.defaultProps = {
  active: false
};

export {Card4}
